export default __webpack_public_path__ + "static/media/Gallery4.0e31532a.jpg";